import { createI18n } from 'vue-i18n';
import en from './locales/en.json';
import fr from './locales/fr.json';

const messages = {
  en,
  fr
};

// Function to determine initial locale
const getInitialLocale = () => {
  // 1. Check if user has saved preference
  const savedLanguage = localStorage.getItem('preferred-language');
  if (savedLanguage && (savedLanguage === 'en' || savedLanguage === 'fr')) {
    return savedLanguage;
  }
  
  // 2. Check environment variable
  if (process.env.VUE_APP_LOCALE && (process.env.VUE_APP_LOCALE === 'en' || process.env.VUE_APP_LOCALE === 'fr')) {
    return process.env.VUE_APP_LOCALE;
  }
  
  // 3. Detect browser language
  const browserLanguage = navigator.language || navigator.userLanguage;
  const languageCode = browserLanguage.split('-')[0]; // Extract language code (e.g., 'en' from 'en-US')
  
  if (languageCode === 'en' || languageCode === 'fr') {
    return languageCode;
  }
  
  // 4. Default to French
  return 'fr';
};

const i18n = createI18n({
  legacy: false,
  locale: getInitialLocale(),
  fallbackLocale: 'en', // set fallback locale
  messages, // set locale messages
  globalInjection: true,
  allowComposition: true,
});

export default i18n; 